import { render, staticRenderFns } from "./table-header-groups.vue?vue&type=template&id=270ce037"
import script from "./table-header-groups.vue?vue&type=script&lang=js"
export * from "./table-header-groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports